export const NAVEGAR_BREADCRUMB = "NAVEGAR_BREADCRUMB"
